// @flow

import { PureComponent } from 'react';

type State = {
  event: Event | null
};

export default class DisableDoubleTapZoom extends PureComponent<*, State> {
  componentDidMount() {
    document.addEventListener('touchend', this.touchendEventHandler);
  }

  componentWillUnmount() {
    document.removeEventListener('touchend', this.touchendEventHandler);
  }

  state = {
    event: null
  };
  lastTouch: number;

  touchendEventHandler = (event: TouchEvent) => {
    const thisTouch = Date.now();
    if (this.lastTouch && thisTouch - this.lastTouch < 300) {
      event.preventDefault();
      (event.target: any).click();
    }
    this.lastTouch = thisTouch;
  };

  render() {
    return null;
  }
}
